
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { TAnswerBlock } from "../TAnswerBlocks";
import { API_ROUTES } from "@/utils/API";
import { SMQuestionnaire } from "@/store";
import { API_TEmployee, TEmployee, convertEmployees } from "@/models/employee_working_status";

const DEFAULT_WORKING_STATUSES = "Employed,,Leaving,,Leaver";
const EMPLOYED_WORKING_STATUS = "Employed";

@Component
export default class AnswerBlockEmployeeMultiselect extends Vue {
  @Prop({ type: Object, default: () => ({}) }) readonly answerBlockData!: TAnswerBlock;
  @Prop({ type: Number, default: () => 0 }) readonly index: number | undefined;
  @Prop({ type: Number, default: () => 0 }) readonly loopIndex: number | undefined;
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;

  isChecked = false;

  toggleChecked() {
    this.isChecked = !this.isChecked;
  }

  get workingStatus() {
    return this.answerBlockData.url || DEFAULT_WORKING_STATUSES;
  }

  get isWorkingStatusEmployed() {
    return this.workingStatus === EMPLOYED_WORKING_STATUS;
  }

  get isMultiSelectDisabled() {
    if (this.disabled) return true;

    return !this.options.length;
  }

  updateAnswer(value: string) {
    if (this.index === null) return;

    SMQuestionnaire.updateAnswer({
      index: this.index,
      value: value,
      required: this.answerBlockData.is_required,
      answer_block_id: this.answerBlockData.ID,
      answer_block_alias: this.answerBlockData.answer_block_alias,
      loop_index: this.loopIndex,
      condition: this.answerBlockData.condition,
    });

    if (value) SMQuestionnaire.setCanGoNext(true);
  }

  @Watch("isChecked")
  updateChecked(value: string) {
    if (value) SMQuestionnaire.setCanGoNext(false);

    if (!value) this.updateAnswer("");
  }

  @Watch("input")
  updateInput(value: string) {
    if (!value) this.updateAnswer("");
  }

  @Watch("disabled")
  onChangeDisabled(isDisabled: boolean) {
    if (isDisabled) this.isChecked = false;
  }

  isLoading = false;

  get userflowID() {
    return SMQuestionnaire.userflowID;
  }

  options: TEmployee[] = [];

  async fetchEmployees() {
    try {
      this.isLoading = true;

      const { data } = await this.axios.get<API_TEmployee[]>(
        API_ROUTES.USERFLOW_EMPLOYEES(this.userflowID),
        {
          params: { working_status: this.workingStatus },
        }
      );

      if (!data) return;

      this.options = data.map((a: API_TEmployee) => convertEmployees(a));
    } finally {
      this.isLoading = false;
    }
  }

  input = "";

  async created() {
    const answer = SMQuestionnaire.answers.find(
      (answer) => answer.answer_block_id === this.answerBlockData.ID
    );

    if (this.index == null || !answer) return;

    this.isChecked = !!answer.value;

    this.input = answer.value;

    await this.fetchEmployees();

    if (this.isChecked) {
      setTimeout(() => {
        SMQuestionnaire.setCanGoNext(true);
      }, 100);
    }
  }
}
